import { DefineGetters } from "vuex-type-helper";
import { ChartGetters, ChartState } from "./types";

export const getters: DefineGetters<ChartGetters, ChartState> = {};
